import { BasicDepartmentInfo } from 'models/Department';
import { SelectOption } from 'models/SelectOption';

// Convert institution IDs to option format for UI fields
export const getInstitutionOptions = (
  institutionIds: number[],
  institutions: BasicDepartmentInfo[]
): SelectOption<number>[] => {
  const institutionsMap = new Map(institutions.map((inst) => [inst.id, inst]));

  return institutionIds
    .map((id) => institutionsMap.get(id))
    .filter((inst): inst is BasicDepartmentInfo => inst !== undefined)
    .map((inst) => ({ value: inst.id, label: `${inst.name} (${inst.id})` }));
};
